import type { introspection } from '@/graphql-env.js';
import { initGraphQLTada } from 'gql.tada';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    ID: string;
    String: string;
    Int: number;
    Float: number;
    Boolean: boolean;
    ISO8601Date: string;
    ISO8601DateTime: string;
  };
}>();

export { maskFragments, readFragment } from 'gql.tada';
export type {
  FragmentOf,
  ResultOf,
  TadaDocumentNode,
  VariablesOf,
} from 'gql.tada';
